import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-rocket',
  templateUrl: './rocket.component.html',
  styleUrls: ['./rocket.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RocketIconComponent {}
